import React, { useRef, Suspense, useState } from "react";
import { NavLink } from "react-router-dom";
import BookCenterImg from "../assets/aboutBookImg.png";
import Logo from "../assets/Logo.png";
import Authencity from "../assets/authText.png";
import Substance from "../assets/subText.png";
import Scroll from "../assets/scrollD.png";
import Target from "../assets/target.png";
import leftText from "../assets/leftText.png";
import rightText from "../assets/rightText.png";
import dashedArrow from "../assets/dashedArrow.png";
import { motion } from "framer-motion";
import { Canvas, useFrame } from "@react-three/fiber";
import { Html, useGLTF, OrbitControls, Stars } from "@react-three/drei";
import * as THREE from "three";
import { set } from "react-hook-form";
import aboutIMGS from "./aboutIMGS";

function AboutSection() {
  const Model = () => {
    const gltf = useGLTF("/scene.gltf", true);
    return <primitive object={gltf.scene} dispose={null} />;
  };

  const Lights = () => {
    return (
      <>
        <ambientLight intensity={0.3} />
        <directionalLight position={[10, 10, 5]} intensity={1} />
        <directionalLight position={[0, 10, 0]} intensity={1.5} />
        <spotLight intensity={1} position={[1000, 0, 0]} />
      </>
    );
  };

  return (
    <div>
      <div className="h-screen w-full relative flex items-center justify-center">
        <NavLink
          to="/homepage"
          className="absolute top-5 left-5 flex items-center justify-center z-50"
        >
          <motion.img
            src={Logo}
            style={{ width: "45px" }}
            animate={{ opacity: 1, scale: 1 }}
            initial={{ opacity: 0, scale: 0.8 }}
            transition={{ ease: "easeOut", duration: 0.3, delay: 0.7 }}
          />
        </NavLink>
        <div className="relative w-full h-full">
          {/*}
          <motion.img
            src={BookCenterImg}
            animate={{ opacity: 1, scale: 1 }}
            initial={{ opacity: 0, scale: 0.9 }}
            transition={{ ease: "easeOut", duration: 0.3 }}
  />{*/}
          <Canvas className="absolute top-0 left-0">
            <Stars count={200} />
            <OrbitControls
              autoRotate={true}
              autoRotateSpeed={0.4}
              enableZoom={false}
            />
            <Lights />
          </Canvas>
          <motion.div
            className="absolute bottom-0 w-full h-full pb-7 pt-44  flex flex-row gap-5 justify-center items-center"
            animate={{ y: 0, opacity: 1, scale: 1, y: 0 }}
            initial={{ y: 100, opacity: 0, scale: 0.8, y: -10 }}
            transition={{ ease: "easeOut", duration: 0.5, delay: 0.9 }}
          >
            {aboutIMGS.map((img) => {
              return (
                <div
                  className={
                    img.id % 2 == 0
                      ? "w-14 h-[70%] rounded-xl overflow-hidden relative translate-y-5 hover:w-52 ease-in-out duration-500 transition-all hover:skew-x-3"
                      : "w-14 h-[70%] rounded-xl overflow-hidden relative -translate-y-5 hover:w-52 ease-in-out duration-500 transition-all hover:-skew-x-3"
                  }
                  key={img.id}
                >
                  <img
                    src={img.src}
                    alt={img.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute top-0 flex justify-center items-center w-full h-full bg-LightOrange bg-opacity-10 opacity-0 hover:opacity-100 transition-all duration-500 ease-in-out text-semibold">
                    <div className="text-xl font-semibold text-zinc-100">
                      {img.title}
                    </div>
                  </div>
                </div>
              );
            })}
          </motion.div>
        </div>
        <motion.img
          src={Scroll}
          className="absolute bottom-0 animate-bounce h-14"
          animate={{ y: 0, opacity: 1, scale: 0.6 }}
          initial={{ y: 100, opacity: 0, scale: 0.6 }}
          transition={{ ease: "easeOut", duration: 0.4 }}
        />
        <motion.div
          className="absolute top-12 font-semibold left-[20rem] text-center right-[20rem] text-2xl text-zinc-200"
          animate={{ y: 0, opacity: 1, y: 0 }}
          initial={{ y: 100, opacity: 0, y: 40 }}
          transition={{ ease: "easeOut", duration: 0.5 }}
        >
          <span className="text-3xl text-OrangyRed font-bold">SkyShare</span>{" "}
          provides an important nuance, complexity, and storytelling support.
        </motion.div>
        <motion.div
          className="absolute top-36 font-medium left-[28rem] text-center right-[28rem] text-sm text-zinc-400"
          animate={{ y: 0, opacity: 1, y: 0 }}
          initial={{ y: 100, opacity: 0, y: 50 }}
          transition={{ ease: "easeOut", duration: 0.5, delay: 0.4 }}
        >
          A living network of curious minds and people whom more about{" "}
          <span className="text-OrangyRed text-base font-semibold">
            Substance
          </span>{" "}
          &{" "}
          <span className="text-OrangyRed text-base font-semibold">
            Authencity
          </span>
          .
        </motion.div>
      </div>
    </div>
  );
}

export default AboutSection;
